import { ref } from 'vue';

export const useOutsideClick = (callback: () => void) => {
  const elementRef = ref<HTMLElement | null>(null);
  
  const handleClickOutside = async (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    
    if (!elementRef.value?.contains(target)) {
      callback();
    }
  };

  return {
    elementRef,
    handleClickOutside
  }
}
